module.exports = __webpack_public_path__ + "static/media/ntg35map.7c060067.jpg";